import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {IWorkLog} from "../../../../../../../utils/interfaces/my_projects/IWorkLog";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";


const useApiCreateWorkLog = (): UseMutationResult<IWorkLog, CustomAxiosError, any> => {
    const {selectedCompany} = useAuth()
    const queryClient = useQueryClient();

    const {post} = useApiCalls()

    async function doCreate({companyToken, data}: {
        companyToken?: string,
        data: any
    }): Promise<IWorkLog> {
        try {
            const response = await post(`/api/company/${companyToken}/my_projects/work_logs`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }


    return useMutation<IWorkLog, CustomAxiosError, any>(
        {
            mutationFn: (
                data
            ) => {
                return doCreate({
                    companyToken: selectedCompany?.company_token,
                    data
                })
            },

        }
    );
};


export default useApiCreateWorkLog;